<template>
  <section class="columns">
    <div class="welcome container">
      <div class="column">
        <div class="user-btn">
          <button @click="userBtnOpen = !userBtnOpen">
            {{ greeting }}
            <span class="icon is-medium">
              <i class="mdi mdi-chevron-down"></i>
            </span>
          </button>

          <transition name="fade">
            <div class="user-dropdown" v-if="userBtnOpen">
              <a
                href="https://yoganow.co.il/%D7%A9%D7%99%D7%A8%D7%95%D7%AA-%D7%9C%D7%A7%D7%95%D7%97%D7%95%D7%AA"
              >
                <span class="icon is-medium">
                  <i class="mdi mdi-18px mdi-help-circle-outline"></i>
                </span>
                שירות לקוחות
              </a>

              <a href="https://yoganow.co.il/?&service=logout">
                <span class="icon is-medium">
                  <i class="mdi mdi-18px mdi-account-outline"></i>
                </span>
                התנתק
              </a>
            </div>
          </transition>
        </div>
        <p>לאיזה שיעור נוכל לכוון אותך היום?</p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: `Welcome`,
  data() {
    return {
      userBtnOpen: false,
    };
  },
  computed: {
    greeting() {
      const d = new Date();
      const time = d.getHours();
      let greet = ``;
      if (time < 12) {
        greet = `בוקר טוב`;
      }
      if (time >= 12 && time <= 14) {
        greet = `צהריים טובים`;
      }
      if (time >= 15 && time <= 17) {
        greet = `אחר צהריים טובים`;
      }
      if (time > 17) {
        greet = `ערב טוב`;
      }
      return `${greet} ${this.$store.getters.firstName}`;
    },

    levelClass() {
      return `level-${this.$store.state.user.level}`;
    },
  },
};
</script>

<style lang="scss">
$black: #191919;
$lilach: #606677;

.user-btn {
  width: 250px;
  position: relative;
  button {
    background-color: transparent;
    border: 0;
    font-size: 1.3rem;
    font-weight: bold;
    cursor: pointer;
    transition: all 300ms ease;
    &:hover {
      box-shadow: 0 0 5px $lilach;
    }
  }
}

.user-dropdown {
  padding: 15px;
  background-color: #ffffff;
  position: absolute;
  top: 36px;
  width: 100%;
  box-shadow: 0 0 2px $lilach;
  z-index: 50;
  a {
    font-size: 18px;
  }
}

.welcome {
  color: $black;
  a {
    display: block;
  }
  p {
    font-size: 16px;
    a {
      display: inline-block;
    }
  }
}
</style>

